const UKEnglish = [
	{
		id: 1,
		listName: 'Numbers to ten',
		minAge: 4,
		maxAge: 6,
		listWords: ['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten']
	},
	{
		id: 2,
		listName: 'Days of the week',
		minAge: 5,
		maxAge: 7,
		listWords: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
	},
	{
		id: 3,
		listName: 'Colours',
		minAge: 4,
		maxAge: 5,
		listWords: ['red', 'blue', 'green', 'yellow', 'white', 'black']
	},
	{
		id: 4,
		listName: 'Colours',
		minAge: 6,
		maxAge: 7,
		listWords: [
			'pink',
			'grey',
			'purple',
			'violet',
			'orange',
			'scarlet',
			'crimson',
			'umber',
			'vermillion'
		]
	},
	{
		id: 5,
		listName: 'Early words',
		minAge: 3,
		maxAge: 5,
		listWords: [
			'dog',
			'cat',
			'man',
			'boy',
			'girl',
			'woman',
			'big',
			'small',
			'fast',
			'slow',
			'go',
			'to',
			'the',
			'run'
		]
	},
	{
		id: 6,
		listName: 'Very long words',
		minAge: 12,
		maxAge: 150,
		listWords: [
			'pneumonoultramicroscopicsilicovolcanoconiosis',
			'Hippopotomonstrosesquippedaliophobia',
			'Supercalifragilisticexpialidocious',
			'Pseudopseudohypoparathyroidism',
			'Floccinaucinihilipilification',
			'Antidisestablishmentarianism',
			'Honorificabilitudinitatibus',
			'Thyroparathyroidectomized',
			'Dichlorodifluoromethane',
			'Incomprehensibilities'
		]
	},
	{
		id: 7,
		listName: 'Palindromes',
		minAge: 7,
		maxAge: 150,
		listWords: [
			'anna',
			'civic',
			'kayak',
			'level',
			'madam',
			'mom',
			'noon',
			'racecar',
			'radar',
			'redder',
			'refer',
			'repaper',
			'rotator',
			'rotor',
			'sagas',
			'solos',
			'stats',
			'tenet',
			'wow'
		]
	},
	{
		id: 8,
		listName: 'testing words',
		minAge: 1,
		maxAge: 150,
		listWords: ['dog', 'cat']
	}
];

export default UKEnglish;
